var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        id: "modal-event",
        title: "Add Event",
        "hide-footer": "",
        size: "lg",
        centered: "",
      },
      on: { hidden: _vm.resetModal },
    },
    [
      _c("validation-observer", {
        ref: "observer",
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var handleSubmit = ref.handleSubmit
              var invalid = ref.invalid
              return [
                _c(
                  "b-form",
                  {
                    on: {
                      submit: function ($event) {
                        $event.preventDefault()
                      },
                    },
                  },
                  [
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { md: "6" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "Event Name",
                                  "label-for": "campaign_name",
                                },
                              },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    rules: "required",
                                    name: "campaign name",
                                    vid: "Campaign Name",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-input", {
                                              attrs: {
                                                state:
                                                  errors.length > 0
                                                    ? false
                                                    : null,
                                              },
                                              model: {
                                                value: _vm.campaignName,
                                                callback: function ($$v) {
                                                  _vm.campaignName = $$v
                                                },
                                                expression: "campaignName",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "6" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "Event Description",
                                  "label-for": "campaign_name",
                                },
                              },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    rules: "required",
                                    name: "campaign name",
                                    vid: "Campaign description",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-input", {
                                              attrs: {
                                                state:
                                                  errors.length > 0
                                                    ? false
                                                    : null,
                                              },
                                              model: {
                                                value: _vm.campaignDescription,
                                                callback: function ($$v) {
                                                  _vm.campaignDescription = $$v
                                                },
                                                expression:
                                                  "campaignDescription",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "12" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "Event Type",
                                  "label-for": "event_type",
                                },
                              },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    rules: "required",
                                    name: "Event Type",
                                    vid: "Event Type",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-select", {
                                              attrs: {
                                                options: _vm.eventTypeOptions,
                                                state:
                                                  errors.length > 0
                                                    ? false
                                                    : null,
                                              },
                                              model: {
                                                value: _vm.eventType,
                                                callback: function ($$v) {
                                                  _vm.eventType = $$v
                                                },
                                                expression: "eventType",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "6" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "Assignee",
                                  "label-for": "assignee",
                                },
                              },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    rules: "required",
                                    name: "Assignee",
                                    vid: "Assignee",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-select", {
                                              attrs: {
                                                options: _vm.assignee_options,
                                                state:
                                                  errors.length > 0
                                                    ? false
                                                    : null,
                                              },
                                              model: {
                                                value: _vm.Assignee,
                                                callback: function ($$v) {
                                                  _vm.Assignee = $$v
                                                },
                                                expression: "Assignee",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "6" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "Start Date",
                                  "label-for": "start_date",
                                },
                              },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    rules: "required",
                                    name: "start date",
                                    vid: "Start Date",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-datepicker", {
                                              attrs: {
                                                id: "start_date",
                                                placeholder: "Choose a date",
                                                local: "en",
                                                min: _vm.currentDate,
                                                state:
                                                  errors.length > 0
                                                    ? false
                                                    : null,
                                                "initial-date": new Date(),
                                              },
                                              model: {
                                                value: _vm.startDate,
                                                callback: function ($$v) {
                                                  _vm.startDate = $$v
                                                },
                                                expression: "startDate",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "6" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: " End Date",
                                  "label-for": "end_date",
                                },
                              },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    rules: "required",
                                    name: "end date",
                                    vid: "End Date",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-datepicker", {
                                              attrs: {
                                                id: "end_date",
                                                placeholder: "Choose a date",
                                                local: "en",
                                                min:
                                                  _vm.startDate ||
                                                  _vm.currentDate,
                                                state:
                                                  errors.length > 0
                                                    ? false
                                                    : null,
                                                "initial-date": new Date(),
                                              },
                                              model: {
                                                value: _vm.endDate,
                                                callback: function ($$v) {
                                                  _vm.endDate = $$v
                                                },
                                                expression: "endDate",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "6" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "Budget",
                                  "label-for": "budget",
                                },
                              },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    rules: "required|numeric|min_value:1",
                                    name: "cost",
                                    vid: "cost",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-input", {
                                              attrs: {
                                                type: "number",
                                                placeholder: "Enter budget",
                                                name: "cost",
                                                state:
                                                  errors.length > 0
                                                    ? false
                                                    : null,
                                              },
                                              model: {
                                                value: _vm.cost,
                                                callback: function ($$v) {
                                                  _vm.cost = $$v
                                                },
                                                expression: "cost",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "6" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "Status",
                                  "label-for": "status",
                                },
                              },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    rules: "required",
                                    name: "Status",
                                    vid: "Status",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-select", {
                                              attrs: {
                                                options: _vm.statusOptions,
                                                state:
                                                  errors.length > 0
                                                    ? false
                                                    : null,
                                              },
                                              model: {
                                                value: _vm.Status,
                                                callback: function ($$v) {
                                                  _vm.Status = $$v
                                                },
                                                expression: "Status",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "6" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "Template",
                                  "label-for": "email_template",
                                },
                              },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    name: "email template",
                                    vid: "Email Template",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-select", {
                                              attrs: {
                                                options: _vm.templateOptions,
                                                state:
                                                  errors.length > 0
                                                    ? false
                                                    : null,
                                              },
                                              on: {
                                                change: _vm.selectTemplate,
                                              },
                                              model: {
                                                value: _vm.selectedTemplateId,
                                                callback: function ($$v) {
                                                  _vm.selectedTemplateId = $$v
                                                },
                                                expression:
                                                  "selectedTemplateId",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "12" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "Subject",
                                  "label-for": "subject",
                                },
                              },
                              [
                                _c("validation-provider", {
                                  attrs: { name: "subject", vid: "Subject" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-input", {
                                              attrs: {
                                                placeholder: "Subject",
                                                name: "subject",
                                                state:
                                                  errors.length > 0
                                                    ? false
                                                    : null,
                                              },
                                              model: {
                                                value:
                                                  _vm.selectedTemplate.subject,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.selectedTemplate,
                                                    "subject",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "selectedTemplate.subject",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "12" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "Content",
                                  "label-for": "email_content",
                                },
                              },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    name: "content",
                                    vid: "Email Content",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("quill-editor", {
                                              attrs: {
                                                state:
                                                  errors.length > 0
                                                    ? false
                                                    : null,
                                              },
                                              model: {
                                                value:
                                                  _vm.selectedTemplate.content,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.selectedTemplate,
                                                    "content",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "selectedTemplate.content",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      {
                        staticClass: "d-flex justify-content-end",
                        attrs: { md: "12" },
                      },
                      [
                        _c(
                          "b-button",
                          {
                            attrs: { type: "submit", variant: "primary" },
                            on: { click: _vm.submitCampaignForm },
                          },
                          [_vm._v("SUBMIT")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }